import watch from 'redux-watch';

export class HighlightedBoundsCtrl {

    constructor($scope, storeServ) {
        this.$scope = $scope;
        this.storeServ = storeServ;

        this.ngOnInit();
    }

    ngOnInit() {
        this.subscribeToStore();
        
        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    subscribeToStore() {
        let watchBounds = watch(this.storeServ.getState, 'boundsToHighlight');

        this.stopWatchingBounds = this.storeServ.subscribe(watchBounds((newBounds, oldBounds, objectPath) => {
            newBounds && this.drawRectangle(newBounds);
        }));
    }

    drawRectangle(bounds) {
        this.rectangle = new google.maps.Rectangle({
            strokeColor: '#FF6600',
            strokeOpacity: 0.6,
            strokeWeight: 2,
            fillColor: '#FF6600',
            fillOpacity: 0.2,
            map: this.map,
            bounds: new google.maps.LatLngBounds(
                new google.maps.LatLng(bounds.southWestLat, bounds.southWestLng),
                new google.maps.LatLng(bounds.northEastLat, bounds.northEastLng)
            )
        });
    }
    
    removeRectangle() {
        if(this.rectangle) this.rectangle.setMap(null);
    }

    ngOnDestroy() {
        this.stopWatchingBounds();

        this.removeRectangle();
    }
}

HighlightedBoundsCtrl.$inject = ['$scope', 'storeServ'];

export function highlightedBoundsComponent() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: HighlightedBoundsCtrl,
        bindToController: {
            map: '='
        }
    };
}